import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';

// Models
import Industry from '../../../../../../models/v2/industry';

// Base
import Badge from '../../../../base/badge';
import Card from '../../../../base/card';
import Col from '../../../../base/col';
import Row from '../../../../base/row';

// Related Components
import Loading from './industries/loading';

export default class Industries extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    persona: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
    selectedIndustries: [],
  }

  componentDidMount() {
    const { profile, persona } = this.props;
    if (isEmptyObject(persona) && (profile.industry_ids || []).length > 0) {
      // For all personas
      Industry
        .where({ id_in: profile.industry_ids})
        .all(false)
        .then((selectedIndustries) => {
          this.setState({
            loading: false,
            selectedIndustries,
          })
        })
    } else if (!isEmptyObject(persona) && (persona.industry_ids|| []).length > 0) {
      // For a specific persona
      Industry
        .where({ id_in: persona.industry_ids })
        .all(false)
        .then((selectedIndustries) => {
          this.setState({
            loading: false,
            selectedIndustries,
          })
        })
    } else {
      this.setState({
        loading: false,
        selectedIndustries: [],
      })
    }
  }

  render() {
    const { loading, selectedIndustries} = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <Card
        border='none'
        className='min-height-80'
        noPadding
      >
        <Row className='margin-top-15 margin-bottom-10' nested>
          <Col s={12} className='med-font dark margin-bottom-10'>
            Industries
          </Col>
          <Col s={12}>
            {
              selectedIndustries.map((industry) => (
                <Badge
                  key={industry.id}
                  text={industry.name}
                />
              ))
            }
            {
              selectedIndustries.length === 0 &&
              <div className='gray-900'>None Selected</div>
            }
          </Col>
        </Row>
      </Card>
    )
  }
}